import React, { useState } from 'react'
import { connect } from 'react-redux';
import { selectItem } from '.';


function ButtonAerialMapItem ( { item, currItem, selectItem, id } ) {
  const itemStripped = item.replace(/\s/g, '-').replace(/’/g, '').replace(/&/g, 'and').replace(/\//ig, '-').toLowerCase(); //replace spaces with - and remove grammar
  const iconSrc = './img/location-map/icon--' + itemStripped + '.png';
  const [icon, setIcon] = useState(iconSrc);
 
  const iconSrcSelected = './img/location-map/icon--' + itemStripped + '-selected.png';
  return (
    <span 
      className={ item === currItem ? 'aerial-map--btn__active' : 'aerial-map--btn' }
    >
      <span className="number">{id}</span>
      {/* <img src={ item === currItem ? iconSrcSelected : icon } width='45' height='45' alt='item icon' onMouseEnter={ () => setIcon(iconSrcSelected) } onMouseOut={ () => setIcon(iconSrc)} /> */}
      <span>{ item }</span>
    </span>
  );
}


const mapStateToProps = (state) => ({
  currItem: state.aerialMap.currItem
});

const mapDispatchToProps = (dispatch) => ({
  selectItem: (currItem) => dispatch(selectItem(currItem))
});

export default connect(mapStateToProps, mapDispatchToProps)(ButtonAerialMapItem);